import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  periodContainer: {
    width: 33,
    height: 32,
    alignItems: 'center',
  },
  periodPoint: (theme, type) => ({
    position: 'absolute',
    width: '75%',
    height: '100%',
    left: type === 'end' ? '-25%' : undefined,
    right: type === 'start' ? '-25%' : undefined,
    backgroundColor: theme.colors.fillColor,
  }),
  periodCircle: theme => ({
    position: 'absolute',
    backgroundColor: theme.colors.activeColor,
    width: 33,
    height: 33,
    borderRadius: 100,
  }),
});
